<div class="row">
  <a
    class="neighborhoodItem__card col-12 bg-white py-3 px-3 rounded mb-4 text-decoration-none"
    [routerLink]="['/neighborhoods', neighborhood?.neighborhoodId]">
    <div class="row">

      <!-- ANCHOR ENCABEZADO -->
      <div class="col-12 mb-3">
        <div class="neighborhoodItem__header d-flex align-items-start justify-content-between gap-2">

          <div>
            <h4 class="neighborhoodItem__name mb-1">
              {{ neighborhood?.name }}
            </h4>
            <div class="neighborhoodItem__address">
              {{ neighborhood?.fullAddress }}
            </div>
          </div>

          <!-- Señal de que la tarjeta completa navega al detalle. Decorativo:
               el destino ya lo comunica el nombre dentro del enlace. -->
          <i class="material-icons neighborhoodItem__chevron" aria-hidden="true">
            chevron_right
          </i>

        </div>
      </div>

      <!-- ANCHOR MODULOS -->
      <div class="col-12 col-xl-7 mb-3">

        <div class="text-secondary mb-2">
          <small><b>Módulos · {{ modulesSummary }}</b></small>
        </div>

        <div class="neighborhoodItem__chips d-flex flex-wrap" role="list">
          @for(chip of moduleChips; track chip.label) {
            <span
              class="neighborhoodItem__chip"
              [class.neighborhoodItem__chip--on]="chip.enabled"
              role="listitem"
              [attr.aria-label]="chip.ariaLabel">
              <i class="material-icons neighborhoodItem__chipIcon" aria-hidden="true">
                {{ chip.icon }}
              </i>
              {{ chip.label }}
            </span>
          }
        </div>

      </div>

      <!-- ANCHOR REQUISITOS DE ACCESO -->
      <div class="col-12 col-xl-5 mb-3">

        <div class="text-secondary mb-2">
          <small><b>Requisitos de acceso</b></small>
        </div>

        <div class="neighborhoodItem__chips d-flex flex-wrap" role="list">
          @for(chip of accessChips; track chip.label) {
            <span
              class="neighborhoodItem__chip"
              [class.neighborhoodItem__chip--on]="chip.enabled"
              role="listitem"
              [attr.aria-label]="chip.ariaLabel">
              <i class="material-icons neighborhoodItem__chipIcon" aria-hidden="true">
                {{ chip.icon }}
              </i>
              {{ chip.label }}
            </span>
          }
        </div>

      </div>

      <!-- ANCHOR CAPACIDAD -->
      <div class="col-12 col-lg-6 mb-3 mb-lg-0">

        <div class="text-secondary mb-2">
          <small><b>Capacidad</b></small>
        </div>

        <div class="neighborhoodItem__stats d-flex flex-wrap">
          @for(detail of capacityDetails; track detail.label) {
            <div class="neighborhoodItem__stat">
              <div class="neighborhoodItem__statLabel text-secondary">
                <small>{{ detail.label }}</small>
              </div>
              <div class="neighborhoodItem__statValue">
                {{ detail.value }}
              </div>
            </div>
          }
        </div>

      </div>

      <!-- ANCHOR COBRANZA Y ZONA -->
      <div class="col-12 col-lg-6">

        <div class="text-secondary mb-2">
          <small><b>Cobranza y zona</b></small>
        </div>

        <div class="neighborhoodItem__stats d-flex flex-wrap">
          @for(detail of billingDetails; track detail.label) {
            <div class="neighborhoodItem__stat">
              <div class="neighborhoodItem__statLabel text-secondary">
                <small>{{ detail.label }}</small>
              </div>
              <div class="neighborhoodItem__statValue">
                @if(detail.amount !== undefined) {
                  {{ detail.amount | currency:'MXN':'symbol-narrow':'1.0-2' }}
                } @else {
                  {{ detail.value }}
                }
              </div>
            </div>
          }
        </div>

      </div>

    </div>
  </a>
</div>
